<template>
  <div id="app">
    <router-view></router-view>    
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  mounted(){
    function plusReady(plus) {
				// 设置系统状态栏背景为红色
				var type = plus.os.name;
				if(type == "iOS") {
					plus.navigator.setStatusBarBackground("#368CBD");
				} else {
					plus.navigator.setStatusBarBackground("#ddd");
				}


			}
			if(window.plus) {
				plusReady(window.plus);
			} else {
				document.addEventListener("plusready", plusReady, false);
			} 
  }
};
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  width: 100%;
  height: 100%;
  /* overflow-x:hidden; */
}
</style>
